import { fromFetch } from 'rxjs/fetch';
import { z } from 'zod/v4';

import { requiredHeaders } from '../../../models/required-headers';
import { selectData } from '../../../utils/select-data';
import { withJwt } from '../../../utils/with-jwt';
import { fleetEnvironment } from '../fleet-environment';
import {
  ConfigurationProfile,
  configurationProfileSchema,
} from '../schemas/configuration-profile.schema';

/**
 * Updates a Configuration Profile
 * @param configurationProfile The Configuration Profile being updated
 * @param isDefault Whether the Configuration Profile will be set as default
 * @returns Data Object containing the updated Configuration Profile
 */
export function putConfigurationProfiles(
  this: unknown,
  configurationProfile: Partial<ConfigurationProfile>
) {
  return withJwt((jwtAuthHeaders) =>
    fromFetch(
      new Request(
        `${fleetEnvironment.resolve(this).configurationProfilesUrl}/${
          configurationProfile.id ?? -1
        }`,
        {
          method: 'PUT',
          headers: {
            ...requiredHeaders,
            ...jwtAuthHeaders,
          },
          body: JSON.stringify({
            ...configurationProfile,
          }),
        }
      )
    )
  ).pipe(
    selectData(
      z.object({
        data: configurationProfileSchema,
        message: z.string().nullable(),
      })
    )
  );
}
